// src/store/rootSaga.js
import { all, fork } from 'redux-saga/effects';
import watchUserRequests from './user/userSaga';
// import watchSomeOtherRequests from './someOtherSlice/someOtherSaga';

export default function* rootSaga() {
  yield all([
    fork(watchUserRequests),
    // fork(watchSomeOtherRequests),
  ]);
}